import createHistory from 'history/createBrowserHistory';
import {routerMiddleware} from 'react-router-redux';
import {applyMiddleware, createStore} from 'redux';
import {apiMiddleware} from 'redux-api-middleware';
import {persistStore} from 'redux-persist';
import thunk from 'redux-thunk';

import reducers from './reducers';

export const history = createHistory(),
    router = routerMiddleware(history),
    middlewares = applyMiddleware(apiMiddleware, thunk, router),
    store = createStore(reducers, middlewares),
    persistor = persistStore(store);


// WEBPACK FOOTER //
// ./src/store.js